// extracted by mini-css-extract-plugin
export var alternate = "_a-j";
export var black = "_a-6";
export var blue = "_a-f";
export var blueLight = "_a-e";
export var brand = "_a-8";
export var darkMode = "_a-b";
export var error = "_a-a";
export var gray = "_a-5";
export var grayBlue = "_a-d";
export var iconWrapper = "_a-3";
export var inactive = "_a-7";
export var indigo = "_a-g";
export var orange = "_a-i";
export var pink = "_a-h";
export var primary = "_a-0";
export var purple = "_a-9";
export var success = "_a-4";
export var warning = "_a-c";
export var white = "_a-1";
export var whiteSuccess = "_a-2";